var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade"}},[_c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fadeLeft","duration":500,"mode":"out-in"}},[_c('router-view')],1),_c('app-refresh-notification'),_c('intercom')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }